import { Button, Form, Input, InputNumber } from "antd";
import { requiredField } from "../common/common";
import { useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate } from "react-router";

export default function () {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const onFinish = (data) => {
    setLoading(true);
    axiosInstance
      .post("courseType", data)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  return (
    <Form onFinish={onFinish} layout="vertical" autoComplete="off">
      <Form.Item label="Nome" rules={[requiredField]} name="title">
        <Input />
      </Form.Item>
      <Form.Item label="Durata in anni" rules={[requiredField]} name="yearsDuration">
        <InputNumber controls={false} precision={0} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Conferma
        </Button>
      </Form.Item>
    </Form>
  );
}
